export const SET_SUBSCRIPTION_ALERT = 'SUBSCRIPTION.SET_SUBSCRIPTION_ALERT'
export const SET_AVAILABLE_PACKAGE = 'SET_AVAILABLE_PACKAGE'
export const SET_SUBSCRIPTION_PACKAGE = 'SET_SUBSCRIPTION_PACKAGE'
export const SET_SUBSCRIPTION_METHOD = 'SET_SUBSCRIPTION_METHOD'
export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'
export const REMOVE_SUBSCRIPTION = 'REMOVE_SUBSCRIPTION'
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS'
